// In-memory handoff for the per-language placement flow, mirroring
// practice/session-handoff.ts. FrameworkDetailPage stashes the pending
// placement (the target language + the REAL language-trainer run to start once
// placement finishes); PlacementPlay takes it. Reloading loses it → PlacementPlay
// redirects back to Create.
import type { StartInputs } from "@/api/create-types";

export interface PendingPlacement {
  language: string;
  frameworkSlug: string;
  frameworkTitle: string;
  /** start_inputs for the real language-trainer run to fire after placement. */
  startInputs: StartInputs;
}

let pending: PendingPlacement | null = null;

export function setPendingPlacement(p: PendingPlacement): void {
  pending = p;
}

export function takePendingPlacement(): PendingPlacement | null {
  const p = pending;
  pending = null;
  return p;
}
